import React from 'react';
import AlertBox, { Heading } from 'components/shared/AlertBox';
import { Button, ButtonGroup } from 'ui';

const CreateError = ({ onDismiss, createType }) => (
  <AlertBox onDismiss={onDismiss}>
    <Heading>{t('common.error')}</Heading>
    {t('common.could_not_create', { create_type: createType })}
    <ButtonGroup alignEnd>
      <Button primary onClick={onDismiss}>
        {t('common.ok')}
      </Button>
    </ButtonGroup>
  </AlertBox>
);

export default CreateError;
